import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useIsTipEnabled } from 'reservations/account/providers/ConfigProvider';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { BaseChecklessPaymentsButton } from 'reservations/checklessPayments/components/BaseChecklessPaymentsButton';
import { ChecklessPaymentsDrawer } from 'reservations/checklessPayments/components/ChecklessPaymentsDrawer';
import { SaveExistingPaymentButton } from 'reservations/checklessPayments/components/SavePaymentButton';
import {
  CHOOSE_HOW_TO_PAY_SUBHEADER,
  SAVE_YOUR_CARD_HEADER
} from 'reservations/checklessPayments/constants';
import { useChecklessPaymentMethod } from 'reservations/checklessPayments/hooks/useChecklessPaymentMethod';
import { ExpiredPayment } from 'reservations/payments/components/ExpiredPayment';
import { getReadableCardType } from 'reservations/payments/helpers/getReadableCardType';

const SelectCardModal = () => {
  const { setValue } = useFormContext();
  const { open } = useModal();
  const {
    cardType,
    cardLast4,
    isExpirationValid,
    id: paymentMethodId
  } = useChecklessPaymentMethod();
  const isTipEnabled = useIsTipEnabled();
  const [editCard, setEditCard] = useState(!isExpirationValid);

  const handleEdit = () => {
    open(ModalType.ChecklessEditCard);
  };

  const handleNext = () => {
    setValue('savedPaymentMethod', paymentMethodId);
    open(
      isTipEnabled
        ? ModalType.ChecklessAddTip
        : ModalType.ChecklessEnrollmentComplete
    );
  };

  return (
    <ChecklessPaymentsDrawer
      headerText={SAVE_YOUR_CARD_HEADER}
      subheaderText={CHOOSE_HOW_TO_PAY_SUBHEADER}
      showFooter
    >
      <FormControl>
        <RadioGroup>
          <FormControlLabel
            sx={{ width: '100%' }}
            value="existing"
            disabled={!isExpirationValid}
            checked={!editCard}
            onChange={() => setEditCard(false)}
            control={<Radio />}
            label={
              <Box display="flex" flexDirection="row" alignItems="center">
                <Typography>
                  {getReadableCardType(cardType)} {cardLast4}
                </Typography>
                <ExpiredPayment isExpirationValid={isExpirationValid} />
              </Box>
            }
          />
          <FormControlLabel
            onChange={() => setEditCard(true)}
            value="new"
            checked={editCard}
            control={<Radio />}
            label={'Replace your card'}
          />
        </RadioGroup>
      </FormControl>
      {!isTipEnabled && !editCard ? (
        <SaveExistingPaymentButton
          handleClick={() => open(ModalType.ChecklessEnrollmentComplete)}
        />
      ) : (
        <BaseChecklessPaymentsButton
          buttonText="NEXT"
          handleClick={editCard ? handleEdit : handleNext}
        />
      )}
    </ChecklessPaymentsDrawer>
  );
};

export default SelectCardModal;
